const menus = [
  {
    icon: 'home',
    title: '首页',
    path: '/'
  },
  {
    icon: 'team',
    title: '用户管理',
    children: [{
      title: '小程序用户',
      path: '/model/user'
    },
    {
      title: '管理员用户',
      path: '/model/admin'
    }
    ]
  },
  // {
  //   icon: 'team',
  //   title: '管理者',
  //   path: '/model/admin'
  // },
  // {
  //   icon: 'team',
  //   title: '用户管理',
  //   path: '/model/user'
  // },
  // {
  //   icon: 'bank',
  //   title: '物业信息管理',
  //   path: '/model/property'
  // },
  {
    icon: 'bank',
    title: '管辖区域',
    children: [
      {
        title: '小区管理',
        path: '/model/residentialQuarters'
      },
      {
        title: '楼号管理',
        path: '/model/floor'
      },
      {
        title: '单元管理',
        path: '/model/unit'
      },
      {
        title: '房号管理',
        path: '/model/room'
      },
      {
        title: '房间管理',
        path: '/model/house'
      },
      {
        title: '审核管理',
        path: '/model/examine'
      }
    ]
  },
  {
    icon: 'file-text',
    title: '订单管理',
    children: [{
      title: '物业订单',
      path: '/model/wyorder'
    },
    {
      title: '取暖订单',
      path: '/model/heatingOrder'
    },
    {
      title: '购物订单',
      path: '/model/shoppingOrder'
    },
    {
      title: '今日订单',
      children: [
        {
          title: '自提订单',
          path: '/model/pickupOrder'
        }, {
          title: '上门配送',
          path: '/model/deliveryOrder'
        }]
    },
    {
      title: '昨日订单',
      children: [
        {
          title: '自提订单',
          path: '/model/pickupOrderYesterday'
        }, {
          title: '上门配送',
          path: '/model/deliveryOrderYesterday'
        }]
    },
    {
      title: '退款订单',
      path: '/model/refundOrder'
    },
    {
      title: '水费订单',
      path: '/model/waterOrder'
    },
    {
      title: '电费订单',
      path: '/order/electricityOrder'
    },
    {
      title: '报修订单',
      path: '/model/repair'
    },
    {
      title: '保洁订单',
      path: '/model/cleaning'
    }]
  },
  {
    icon: 'shop',
    title: '商品管理',
    children: [
      {
        title: '商品分类',
        path: '/model/shopType'
      },
      {
        title: '商品列表',
        path: '/model/goods'
      }
    ]
  },
  {
    icon: 'money-collect',
    title: '卡券管理',
    children: [
      {
        title: '购物代金券',
        children: [
          {
            title: '自动发放',
            path: '/model/couponActivity'
          },
          {
            title: '手动发放',
            path: '/model/couponManual'
          }
        ]
      },
      {
        title: '物业费抵扣券',
        path: '/model/couponProperty'
      }
      // {
      //   title: '卡券记录',
      //   path: '/model/couponRecord'
      // }
    ]
  },
  {
    icon: 'environment',
    title: '自提点管理',
    path: '/model/selfPoint'
  },
  // {
  //   icon: 'rest',
  //   title: '保洁管理',
  //   path: '/model/cleaning'
  // },
  // {
  //   icon: 'tool',
  //   title: '维修管理',
  //   path: '/model/repair'
  // },
  {
    icon: 'notification',
    title: '公告管理',
    path: '/model/notice'
  },
  {
    icon: 'red-envelope',
    title: '充值记录',
    path: '/model/walletrecord'
  },
  {
    icon: 'setting',
    title: '基础设置',
    children: [{
      title: '小程序配置',
      path: '/setting'
    }]
  }
]
export default menus
